import {
  fadeInit,
  fadeAnim,
  fadeVideoInit,
  fadeVideoAnim,
  fadeAnimReverse,
} from './animations/fade';
import { lineInit, lineAnim } from './animations/line';
import { titleInit, titleAnim } from './animations/title';
import { buttonInit, buttonAnim } from './animations/button';
import { pictureInit, pictureAnim } from './animations/picture';
import { scaleInit, scaleAnim } from './animations/scale';
import { videoInit, videoAnim } from './animations/video';
import { cardInit, cardAnim } from './animations/card';
import { footerInit, footerAnim } from './animations/footer';
import { menuInit, menuOpen, menuClose } from './animations/menu';
import staggerAnim from './animations/stagger';

const initials = new Map();
initials.set('fade', fadeInit);
initials.set('fadeVideo', fadeVideoInit);
initials.set('line', lineInit);
initials.set('title', titleInit);
initials.set('button', buttonInit);
initials.set('picture', pictureInit);
initials.set('footer', footerInit);
initials.set('video', videoInit);
initials.set('card', cardInit);
initials.set('scale', scaleInit);
initials.set('menu', menuInit);

const animations = new Map();
animations.set('fade', fadeAnim);
animations.set('fadeVideo', fadeVideoAnim);
animations.set('fadeReverse', fadeAnimReverse);
animations.set('line', lineAnim);
animations.set('title', titleAnim);
animations.set('button', buttonAnim);
animations.set('picture', pictureAnim);
animations.set('scale', scaleAnim);
animations.set('footer', footerAnim);
animations.set('video', videoAnim);
animations.set('card', cardAnim);
animations.set('stagger', staggerAnim);
animations.set('menu-open', menuOpen);
animations.set('menu-close', menuClose);

const transitions = new Map();

export { animations, initials, transitions };
